import { createContext } from "react";

const LandLordContext = createContext();

export default LandLordContext;